export default __webpack_public_path__ + "static/media/notfound.0335bf05.png";